<template>
  <img @click="showHint" class="hint" :key="index" :src="hintSrc" v-bind:class="{ pulse: hasHint }" />
</template>

<script>
// eslint-disable-next-line
const hintUsed = require("@/assets/hint-used.png");
// eslint-disable-next-line
const hintUnused = require("@/assets/hint-unused.png");
export default {
  props: {
    index: Number
  },
  methods: {
    showHint() {
      this.$emit("showHint");
    }
  },
  computed: {
    game() {
      return this.$store.state.game;
    },
    hintSrc() {
      return this.index > this.game.hintsUsed ? hintUnused : hintUsed;
    },
    hasHint() {
      return this.index > this.game.hintsUsed && this.game.isLast10;
    }
  }
};
</script>

<style lang="scss" scoped>
.hint {
  display: inline-block;
  cursor: pointer;
  width: rems(63px);
  height: rems(57px);
}
.tiny .hint {
  width: rems(53px);
  height: rems(47px);
}
.pulse {
  animation: pulse-hint 0.5s linear infinite;
}

@keyframes pulse-hint {
  0% {
    transform: scale(1, 1);
  }
  20% {
    transform: scale(0.95, 0.95);
  }
  40% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
